/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_Code_HeadingInputs */

const en_password_reset_code_heading = /** @type {(inputs: Password_Reset_Code_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset your password`)
};

const es_password_reset_code_heading = /** @type {(inputs: Password_Reset_Code_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restablece tu contraseña`)
};

/**
* | output |
* | --- |
* | "Reset your password" |
*
* @param {Password_Reset_Code_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_code_heading = /** @type {((inputs?: Password_Reset_Code_HeadingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_Code_HeadingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_code_heading(inputs)
	return en_password_reset_code_heading(inputs)
});